import React from 'react';
import { Pagination } from '@mq/voltron-table';

export default function PaginationWrapper({ refetch, nextPageToken, prevPageToken }) {
  const handleNextClick = () => refetch({ page_token: nextPageToken });
  const handlePreviousClick = () => refetch({ page_token: prevPageToken });
  return (
    <Pagination
      startIndex={0}
      isMore={Boolean(nextPageToken)}
      isLess={Boolean(prevPageToken)}
      handleNextClick={handleNextClick}
      handlePreviousClick={handlePreviousClick}
    />
  );
}
